import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import React from 'react';
import styled from 'styled-components/native';
import QuestItem from './QuestItem';
export default function ChallengeDetailQuestSection({ quests, }) {
    const getChunkQuests = () => {
        const result = [];
        for (let i = 0; i < quests.length; i += 2) {
            result.push(quests.slice(i, i + 2));
        }
        return result;
    };
    const chunkQuests = getChunkQuests();
    return (_jsxs(Container, { children: [_jsx(Title, { children: "\uB098\uC758 \uD018\uC2A4\uD2B8" }), _jsx(Column, { children: chunkQuests.map((rowItems, rowIndex) => (_jsx(Row, { children: rowItems.map(quest => (_jsx(QuestItem, Object.assign({}, quest), quest.id))) }, rowIndex))) })] }));
}
const Container = styled.View({
    paddingHorizontal: 15,
});
const Title = styled.Text({
    color: color.black,
    fontSize: 20,
    fontFamily: font.pretendardBold,
    padding: 10,
});
const Column = styled.View({
    gap: 8,
});
const Row = styled.View({
    gap: 8,
    flexDirection: 'row',
});
